import * as jsts from "jsts";
import { Color3 } from "@babylonjs/core/Maths/math.color";
import { CreateLineSystem } from "@babylonjs/core/Meshes/Builders/linesBuilder";
import { Mesh } from "@babylonjs/core/Meshes/mesh";
import { Vector3 as BJSVector3 } from "@babylonjs/core/Maths/math.vector";
import { RoomManager } from '../../RoomManager';
import { CsgUtils } from "../CsgUtils";
import { Util } from '../../utils/Util';
import { CameraModeMask, CameraControl } from '@egr/wcf/modules/core/view/CameraControl';
import { PbrMaterial } from '@egr/wcf/modules/core/mdl';
import { ShadowGenerator } from "@egr/wcf/modules/core/rendering/ShadowGenerator";
export class ElementGeometry {
    constructor(pRoomManager, pRoomElement) {
        this.mRoomElement = pRoomElement;
        this.mRoomManager = pRoomManager;
        this.mScene = pRoomManager.app.model.scene;
        this.mMatManager = pRoomManager.app.model.materials;
    }
    get canMirrorH() {
        return (true);
    }
    get canMirrorV() {
        return (true);
    }
    getInitialParams() {
        let tParams = {};
        tParams.width = 1;
        tParams.depth = 1;
        tParams.height = 1;
        tParams.text = "Text";
        tParams.floorOffset = 1;
        tParams.color = "#ffffff";
        tParams.imageURL = "";
        return (tParams);
    }
    create2dGeometry(pParent) {
        //
    }
    create3dGeometry(pParent) {
        //
    }
    createSpecialGeometry(pParent) {
        //
    }
    createAdditionalGeometry(pParent) {
        //
    }
    create4dGeometry(pParent) {
        //
    }
    getProperties() {
        return (null);
    }
    serializeIOData() {
        return (null);
    }
    loadIOData(pData, pContext) {
        //
    }
    getEOXDescription(pDocument, pParentNode) {
        //
    }
    prepareMesh(pMesh, p2d) {
        if (pMesh == null) {
            return;
        }
        if (p2d) {
            CameraControl.SetMeshCameraModeMask(pMesh, CameraModeMask.Top | CameraModeMask.Bottom);
        }
        else {
            //not visible in top and bottom view
            CameraControl.SetMeshCameraModeMask(pMesh, CameraModeMask.All &
                ~CameraModeMask.Top & ~CameraModeMask.Bottom);
        }
        pMesh.freezeWorldMatrix();
    }
    prepare2dMesh(pMesh) {
        if (pMesh == null)
            return;
        CameraControl.SetMeshCameraModeMask(pMesh, CameraModeMask.Top | CameraModeMask.Bottom);
        pMesh.freezeWorldMatrix();
    }
    prepare3dMesh(pMesh) {
        if (pMesh == null)
            return;
        pMesh.freezeWorldMatrix();
        //not visible in top and bottom view
        CameraControl.SetMeshCameraModeMask(pMesh, CameraModeMask.All &
            ~CameraModeMask.Top & ~CameraModeMask.Bottom);
    }
    createCrossHair(pParent) {
        let tHelpLines = new Array();
        // ref point lines
        tHelpLines = [];
        let tRefPointIdx = this.mRoomElement.RefPointIndices;
        let tP1 = tRefPointIdx.P1;
        let tP2 = tRefPointIdx.P2;
        tHelpLines.push([this.mRoomElement.Params.ElementPoints[tP1], this.mRoomElement.RefPoint]);
        tHelpLines.push([this.mRoomElement.Params.ElementPoints[tP2], this.mRoomElement.RefPoint]);
        let tLinesRef = CreateLineSystem("shape_helplines", { lines: tHelpLines }, this.mScene);
        tLinesRef.parent = pParent;
        tLinesRef.renderingGroupId = 2;
        this.mRoomManager.app.model.layers.setMeshLayer(tLinesRef, "room:ShapeHelpLines");
        tLinesRef.color = Color3.FromHexString("#FF0000");
        ShadowGenerator.disableMeshShadow(tLinesRef);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    createCSG_Hill(pParent, pBasePolygon, pcanCreateHill) {
        let tRes = {};
        tRes.mesh = null;
        tRes.offsetPoints = null;
        tRes.canCreateHill = pcanCreateHill;
        const tHillHeight = this.mRoomElement.Params.hillHeight;
        const tHillType = this.mRoomElement.Params.terrainType;
        const tREType = this.mRoomElement.type.toString();
        let tCAGCSGOffset = this.createOffsetCSG_Hill(pBasePolygon, tRes);
        if (tHillType === 'Top') {
            for (let tP1 of pBasePolygon) {
                tP1.addInPlace(this.mRoomElement.Params.hillTopOffset);
            }
        }
        // hill base plane / initial 2d shape
        let tPoints = new Array();
        for (let tPoint of pBasePolygon) {
            tPoints.push(new CSG.Vector2D(tPoint.x, tPoint.z));
        }
        let tCAGBase = CAG.fromPointsNoCheck(tPoints);
        if (tCAGBase.isSelfIntersecting()) {
            this.mRoomElement.setCAG(null);
            return (tRes);
        }
        tRes.canCreateHill = false;
        let tCSGBase = null;
        tCSGBase = Util.CAG2CSG(tCAGBase);
        this.mRoomElement.setCAG(tCAGBase);
        this.mRoomElement.setCAGoriginal(tCAGBase);
        if (tCAGCSGOffset.CAG != null && (!tCAGCSGOffset.CAG.isSelfIntersecting()) && (tHillType !== 'Flat')) {
            if (tCAGCSGOffset.CSG != null) {
                tRes.canCreateHill = true;
            }
            if (tHillType === "Top") {
                tCSGBase = tCSGBase.translate([0, tHillHeight, 0]);
                this.mRoomElement.setCAG(tCAGCSGOffset.CAG);
                this.mRoomElement.setCAGoriginal(tCAGCSGOffset.CAG);
            }
            if (tHillType === "Bottom" && tCAGCSGOffset.CSG != null) {
                tCAGCSGOffset.CSG = tCAGCSGOffset.CSG.translate([0, tHillHeight, 0]);
                tRes.canCreateHill = true;
            }
        }
        let tMeshes_base = null;
        let tMeshes_offset = null;
        switch (tHillType) {
            case 'Flat':
                tMeshes_base = this.createMeshOfCSG(pParent, RoomManager.ROOM_SHAPE2D_PREFIX + tREType, tCSGBase, this.mRoomElement.localMaterial);
                if (tMeshes_base == null) {
                    return (tRes);
                }
                tRes.mesh = tMeshes_base[0];
                return (tRes);
            case 'Bottom':
                tMeshes_base = this.createMeshOfCSG(pParent, RoomManager.ROOM_SHAPE2D_PREFIX + tREType, tCSGBase, this.mRoomElement.localMaterial);
                tMeshes_offset = this.createMeshOfCSG(pParent, RoomManager.ROOM_SHAPE2D_PREFIX + tREType, tCAGCSGOffset.CSG, this.mRoomElement.localMaterial);
                if (tMeshes_base == null) {
                    return (tRes);
                }
                tRes.mesh = tMeshes_base[0];
                return (tRes);
            case 'Top':
                tMeshes_base = this.createMeshOfCSG(pParent, RoomManager.ROOM_SHAPE2D_PREFIX + tREType, tCSGBase, this.mRoomElement.localMaterial);
                tMeshes_offset = this.createMeshOfCSG(pParent, RoomManager.ROOM_SHAPE2D_PREFIX + tREType, tCAGCSGOffset.CSG, this.mRoomElement.localMaterial);
                if (tMeshes_offset == null) {
                    return (tRes);
                }
                tRes.mesh = tMeshes_offset[0];
                return (tRes);
            default:
                break;
        }
        return (tRes);
    }
    createMeshOfCSG(pParent, pName, pCSG, pMaterial) {
        if (pCSG == null) {
            return (null);
        }
        let tMeshes = CsgUtils.buildMeshes(pCSG, this.mScene);
        if (tMeshes == null)
            return (null);
        for (let tMesh of tMeshes) {
            tMesh.parent = pParent;
            tMesh.name = pName;
            tMesh.receiveShadows = true;
            if (this.mRoomElement.type !== "Hedge") {
                ShadowGenerator.disableMeshShadow(tMesh);
            }
            tMesh.material = pMaterial;
            if (tMesh.material != null) {
                tMesh.material.backFaceCulling = false;
            }
            if (this.mRoomElement.GroupMeshOpacity !== 1) {
                tMesh.renderingGroupId = 1;
            }
            tMesh.visibility = this.mRoomElement.GroupMeshOpacity;
        }
        return (tMeshes);
    }
    createMeshOfPoints(pParent, pName, pPoints, pMaterial) {
        if (pPoints.length < 3) {
            return (null);
        }
        let tCAGCSG = this.createCAGCSGFromPoints(pPoints);
        if (tCAGCSG.CAG == null || tCAGCSG.CSG == null) {
            return (null);
        }
        let tMeshes = CsgUtils.buildMeshes(tCAGCSG.CSG, this.mScene);
        if (tMeshes == null)
            return (null);
        for (let tMesh of tMeshes) {
            tMesh.parent = pParent;
            tMesh.name = pName;
            ShadowGenerator.disableMeshShadow(tMesh);
            tMesh.material = pMaterial;
            if (tMesh.material != null) {
                tMesh.material.backFaceCulling = false;
            }
            if (this.mRoomElement.GroupMeshOpacity !== 1) {
                tMesh.renderingGroupId = 1;
            }
            tMesh.visibility = this.mRoomElement.GroupMeshOpacity;
        }
        return (tMeshes[0]);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    createCAGCSGFromPoints(pPoints) {
        let tRes = {};
        tRes.CAG = null;
        tRes.CSG = null;
        let tcorDirPolygon = Util.correctPolygonDirection3(pPoints);
        // offset plane
        let tPointsOffset = new Array();
        let tCAGOffset = null;
        for (let tPoint of tcorDirPolygon) {
            tPointsOffset.push(new CSG.Vector2D(tPoint.x, tPoint.z));
        }
        tCAGOffset = CAG.fromPointsNoCheck(tPointsOffset);
        // if (tCAGOffset == null || (tCAGOffset.isSelfIntersecting())) {
        //     return (tRes);
        // }
        if (tCAGOffset == null) {
            return (tRes);
        }
        let tCSGOffset = Util.CAG2CSG(tCAGOffset, this.mRoomElement.height);
        tRes.CAG = tCAGOffset;
        tRes.CSG = tCSGOffset;
        return (tRes);
    }
    curveFunction(valueEdge) {
        switch (valueEdge) {
            case 'Hard': return getLine();
            case 'Medium': return getCosineCurve();
            case 'Soft': return this.mRoomManager.hill_GaussCurve;
            default: return [];
        }
    }
    limitOffsetDistance() {
        const tnodePos = this.mRoomElement.node.position.clone();
        const tnodeOff = tnodePos.add(this.mRoomElement.Params.hillTopOffset);
        const toffDist = BJSVector3.Distance(tnodePos, tnodeOff);
        const tdirV = (tnodeOff.subtract(tnodePos)).normalize().scale(this.mRoomElement.Params.hillOffset);
        if (toffDist > this.mRoomElement.Params.hillOffset) {
            this.mRoomElement.Params.hillTopOffset = tdirV;
        }
    }
    getGrayPlasticMaterial() {
        let tMat = this.mMatManager.getMaterial(ElementGeometry.MAT_KEY_GRAYPLASTIC);
        if (tMat == null) {
            tMat = new PbrMaterial("", this.mMatManager);
            tMat.albedoColor = new Color3(0.8, 0.8, 0.8).toLinearSpace();
            tMat.metallic = 0;
            tMat.roughness = 0.2;
            this.mMatManager.addMaterial(ElementGeometry.MAT_KEY_GRAYPLASTIC, tMat);
        }
        return (tMat);
    }
    getDarkGrayPlasticMaterial() {
        let tMat = this.mMatManager.getMaterial(ElementGeometry.MAT_KEY_GRAYPLASTIC);
        if (tMat == null) {
            tMat = new PbrMaterial("", this.mMatManager);
            tMat.albedoColor = new Color3(0.4, 0.4, 0.4).toLinearSpace();
            tMat.metallic = 0;
            tMat.roughness = 0.2;
            this.mMatManager.addMaterial(ElementGeometry.MAT_KEY_GRAYPLASTIC, tMat);
        }
        return (tMat);
    }
    mergeShapeMeshes(pParent, callback) {
        const tgrpMeshes = pParent.getChildMeshes();
        const tfiltMesh = [];
        const tisHill = this.mRoomElement.Params.terrainType !== "Flat";
        const tHillSuffix = tisHill ? '_hill' : '';
        for (let tm of tgrpMeshes) {
            const tidx_outline = tm.name.indexOf(RoomManager.ROOM_SHAPE2D_SUFFIXOUTLINE);
            const tidx_pickline = tm.name.indexOf(RoomManager.ROOM_SHAPE2D_SUFFIXPICKLINE);
            const tidx_bisectorLine = tm.name.indexOf(RoomManager.ROOM_SHAPE2D_BISECTORLINE);
            if (tidx_outline >= 0 || tidx_pickline >= 0 || tidx_bisectorLine >= 0) {
                continue;
            }
            tfiltMesh.push(tm);
        }
        if (tfiltMesh.length > 1) {
            for (let tm of tfiltMesh) {
                tm.parent = null;
            }
            let tmm = Mesh.MergeMeshes(tfiltMesh, true);
            if (tmm != null) {
                tmm.parent = pParent;
                tmm.material = this.mRoomElement.localMaterial;
                tmm.name = RoomManager.ROOM_SHAPE2D_PREFIX + this.mRoomElement.type.toString() + tHillSuffix;
                tmm.id = RoomManager.ROOM_SHAPE2D_PREFIX + this.mRoomElement.type.toString() + tHillSuffix;
                callback(tmm);
            }
        }
    }
    //// private ///////////////////////////////////////////////////////////////////////////////
    // tslint:disable-next-line:cyclomatic-complexity
    createOffsetCSG_Hill(pBasePoly, pCSGHillresult) {
        let tRes = {};
        tRes.CAG = null;
        tRes.CSG = null;
        const tHillOffset = this.mRoomElement.Params.hillOffset;
        const tHillType = this.mRoomElement.Params.terrainType;
        if (tHillType === "Flat") {
            return (tRes);
        }
        let tbasePolygon = pBasePoly;
        let toffsetPoints = offset(tbasePolygon, (tHillType === 'Top' ? tHillOffset : -tHillOffset));
        if (toffsetPoints.length !== tbasePolygon.length) {
            return (tRes);
        }
        // offset plane
        let tPointsOffset = new Array();
        let tCAGOffset = null;
        toffsetPoints = Util.correctPolygonDirection3(toffsetPoints);
        this.limitOffsetDistance();
        if (tHillType === 'Bottom') {
            for (let tP1 of toffsetPoints) {
                tP1.addInPlace(this.mRoomElement.Params.hillTopOffset);
            }
        }
        if (toffsetPoints.length === tbasePolygon.length) {
            pCSGHillresult.offsetPoints = toffsetPoints;
        }
        for (let tPoint of toffsetPoints) {
            tPointsOffset.push(new CSG.Vector2D(tPoint.x, tPoint.z));
        }
        if (toffsetPoints.length === tbasePolygon.length) {
            tCAGOffset = CAG.fromPointsNoCheck(tPointsOffset);
        }
        if (tCAGOffset == null || (tCAGOffset.isSelfIntersecting())) {
            return (tRes);
        }
        let tCSGOffset = Util.CAG2CSG(tCAGOffset);
        tRes.CAG = tCAGOffset;
        tRes.CSG = tCSGOffset;
        return (tRes);
    }
}
ElementGeometry.CLIPPER_SCALING_VALUE = 1000000000;
ElementGeometry.CLIPPER_MITER_LIMIT = 1;
//// protected /////////////////////////////////////////////////////////////////////////////
ElementGeometry.PROP_KEY_WINDOWSEGMENTS = "room:Windows:Segments";
ElementGeometry.PROP_KEY_BLIND = "room:Windows:Blind";
ElementGeometry.PROP_KEY_BLINDOPENINGANGLE = "room:Windows:BlindOpeningAngle";
ElementGeometry.PROP_KEY_BLINDOPENINGWIDTH = "room:Windows:BlindOpeningWidth";
ElementGeometry.PROP_KEY_PRIVACYFILTER = "room:Windows:PrivacyFilter";
ElementGeometry.MAT_KEY_GRAYPLASTIC = "room:openingGeometry:grayPlastic";
export function getCosineCurve() {
    const res = [];
    for (let i = 1; i > 0; i -= 0.1) {
        res.push(Math.cos(i * Math.PI / 2));
    }
    return res;
}
export function getLine() {
    return [
        0,
        1
    ];
}
function offset(polygon, spacing) {
    const geoInput = vectorCoordinates2JTS(polygon);
    if (!geoInput[0].equals(geoInput[geoInput.length - 1])) {
        geoInput.push(geoInput[0]);
    }
    const geometryFactory = new jsts.geom.GeometryFactory();
    const ring = geometryFactory.createLineString(geoInput);
    const shell = geometryFactory.createPolygon(ring, []);
    const bufferParameters = new jsts.operation.buffer.BufferParameters();
    bufferParameters.setEndCapStyle(jsts.operation.buffer.BufferParameters.CAP_FLAT);
    bufferParameters.setQuadrantSegments(1);
    bufferParameters.setJoinStyle(jsts.operation.buffer.BufferParameters.JOIN_MITRE);
    const buffered = shell.buffer(spacing, bufferParameters);
    const simplified = simplify();
    const points = simplified.getCoordinates();
    if (points.length === 0) {
        return [];
    }
    if (points[0].equals(points[points.length - 1])) {
        points.pop();
    }
    return points.map((x) => new BJSVector3(x.x, 0, x.y));
    function simplify() {
        let a;
        let b = buffered;
        let tol = 0.01;
        const targetVertexCount = polygon.length;
        let tNumPoint = b.getNumPoints();
        while (targetVertexCount + 1 < tNumPoint) {
            a = b;
            b = jsts.simplify.TopologyPreservingSimplifier.simplify(b, tol);
            tNumPoint = b.getNumPoints();
            if (a.getNumPoints() === tNumPoint) {
                tol *= 2;
                if (tol > 50) {
                    break;
                }
            }
        }
        return b;
    }
}
function vectorCoordinates2JTS(tPoints) {
    return tPoints.map((point) => new jsts.geom.Coordinate(point.x, point.z));
}
function getSteps(points) {
    const step = 1 / (points.length - 1);
    const res = [];
    for (let i = 0; i < points.length; i++) {
        res.push(i * step);
    }
    return res;
}
function getInterpolatedPolygon(a, b, n) {
    const res = [];
    for (let i = 0; i < a.length; i++) {
        res.push(b[i].subtract(a[i]).scale(n).add(a[i]));
    }
    return res;
}
